import { translate } from '../../../i18n';
import { MAX_BOOKING_CAPACITY } from '../../../utils/sport-capacity';
import { AvailabilityCapacityIssue } from './validate-availability-prices';

/**
 * The operator-facing sentence for one capacity problem.
 *
 * Lives in its own module rather than next to the form that first needed it:
 * both save gates (`AddAvailabilitiesModal`, `CreateCourtForm`) show it in a
 * toast, and `CreateCourtForm` is already imported BY `AddAvailabilitiesForm`,
 * so reaching back the other way would close an import cycle.
 *
 * Every kind here is blocking, and each names the offending number — the two
 * gates used to print the duplicate message whatever the kind was, so an
 * out-of-range capacity was reported as a duplicate that did not exist.
 */
export function capacityIssueMessage(issue: AvailabilityCapacityIssue): string {
    switch (issue.kind) {
        case 'duplicate':
            return translate('courts.duplicate_capacity_pricing_detail').replace(
                '{{capacity}}',
                String(issue.capacity),
            );
        case 'unbookable':
            return translate('courts.unbookable_capacity')
                .replace('{{capacity}}', String(issue.capacity))
                .replace('{{max}}', String(MAX_BOOKING_CAPACITY));
        default:
            return translate('courts.invalid_capacity');
    }
}
